import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Result from './Result'
import store from './store'
export default class extends Component {
  constructor(props) {
    super(props)

    const {
      params: { id },
      location: {
        query: { kind }
      }
    } = props
    store.setId(id, kind)
  }

  render() {
    return (
      <HeaderView title="申诉结果">
        <Result />
      </HeaderView>
    )
  }
}
